import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import moment from 'moment';

import { BaseChangedCell } from './BaseChangedCell';

type Props = {
  params: GridRenderCellParams;
  showChanges: boolean;
  field?: string;
};

export const StartEndDateChangedCell = (props: Props) => {
  const { params, showChanges, field } = props;
  const fieldKey = field ?? params.field;

  const changes = params.row.changes;
  const cv = changes?.[fieldKey];

  if (showChanges && cv) {
    return (
      <BaseChangedCell
        oldValue={cv.old ? moment(cv.old).format('L') : ''}
        newValue={cv.new ? moment(cv.new).format('L') : ''}
      />
    );
  }

  return params.value ? moment(params.value).format('L') : '';
};
